export const gitMetadata = {
    "commitHash": "add1dd0fded5795a8930faf371b5cb58cbd92d46",
    "commitHashShort": "add1dd0",
    "branch": "main",
    "isDirty": false,
    "buildTime": "2026-11-04T21:43:27.982Z"
};
//# sourceMappingURL=versionData.js.map